"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Info = function Info(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M12.007 19.506a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-13.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm.468 3.75a1.025 1.025 0 01-1.093-.937c.046-.56.533-.977 1.093-.938.56-.04 1.048.379 1.094.938-.046.56-.534.977-1.094.938zm.444 2.114l-.87 3.284a.653.653 0 00.388.774.312.312 0 01.196.29v.101c0 .172-.14.312-.312.313h-.934a.939.939 0 01-.913-1.177l.87-3.284a.653.653 0 00-.388-.773.312.312 0 01-.196-.29v-.101c0-.173.14-.313.312-.313h.934a.939.939 0 01.913 1.176z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Info);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Info, "Info", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Info.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Info.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9JbmZvLnRzeCJdLCJuYW1lcyI6WyJJbmZvIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxnZEFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQyRTtBQUFBLENBQTdFOztlQVNlLHVCQUFXRixJQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLEkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEluZm86IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xMi4wMDcgMTkuNTA2YTcuNSA3LjUgMCAxMTAtMTUgNy41IDcuNSAwIDAxMCAxNXptMC0xMy43NWE2LjI1IDYuMjUgMCAxMDAgMTIuNSA2LjI1IDYuMjUgMCAwMDAtMTIuNXptLjQ2OCAzLjc1YTEuMDI1IDEuMDI1IDAgMDEtMS4wOTMtLjkzN2MuMDQ2LS41Ni41MzMtLjk3NyAxLjA5My0uOTM4LjU2LS4wNCAxLjA0OC4zNzkgMS4wOTQuOTM4LS4wNDYuNTYtLjUzNC45NzctMS4wOTQuOTM4em0uNDQ0IDIuMTE0bC0uODcgMy4yODRhLjY1My42NTMgMCAwMC4zODguNzc0LjMxMi4zMTIgMCAwMS4xOTYuMjl2LjEwMWMwIC4xNzItLjE0LjMxMi0uMzEyLjMxM2gtLjkzNGEuOTM5LjkzOSAwIDAxLS45MTMtMS4xNzdsLjg3LTMuMjg0YS42NTMuNjUzIDAgMDAtLjM4OC0uNzczLjMxMi4zMTIgMCAwMS0uMTk2LS4yOXYtLjEwMWMwLS4xNzMuMTQtLjMxMy4zMTItLjMxM2guOTM0YS45MzkuOTM5IDAgMDEuOTEzIDEuMTc2elwiXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoSW5mbyk7XG4iXX0=